module.exports = __webpack_public_path__ + "img/kindergarden-building.5e9c3e46.jpg";